<template>
  <div :class="['definition-wrapper', 'conditional', definition.id]">
    <transition name="fade" mode="out-in">
      <spinner-loading v-if="!requestDefinition && loading" :line-size='2' :size="20" line-fg-color='#5dbecd' class="conditional-loading" />
      <template v-else-if="requestDefinition">
        <definition-obj v-for="reqDef in requestDefinition"
          :key="reqDef.id"
          :id="reqDef.id"
          :definitionId="definitionId"
          :reqDef="reqDef"
          :reqObj="getRequestObjectById(reqDef.id)"
          :reqObjForAdd="reqObjForAdd"
          :content="content"
          :modeView="modeView"
          :validateForm="validateForm"
          :validateAddForm="validateAddForm"
          :repeatableGroupId="repeatableGroupId"
          :languageSelected="languageSelected"
          :definitionContentId="definitionContentId"
          :requestObjectForAddModified="requestObjectForAddModified"
          :language="language"
          :visualDefinition="visualDefinition"
          :visuals="visuals"
          :authorization="authorization"
          :type="type"
          :apiparams="apiparams"
          :parentRepeatableGroupCode="repeatableGroupCode"
          :callTask="callTask"
          @refreshDefinition="refreshDefinition"
          @repeatableGroupModified="repeatableGroupModified"
          @activateValidatingAddForm="activateValidatingAddForm"
          @deactivateValidatingAddForm="deactivateValidatingAddForm"
          @errorAddForm="errorAddForm"
          @formAddSaved="formAddSaved"
          @newLanguageSelected="newLanguageSelected"
          @refreshRepeatableGroupCode="refreshRepeatableGroupCode"
          @conditionalDefinitionChange="conditionalDefinitionChangeChild"
          @callSaveByFieldChange="callSaveByFieldChange"
          class="item"
        />
      </template>
      <!--<transition-group v-else-if="requestDefinition" name="fade" mode="out-in"></transition-group>-->
    </transition>
  </div>
</template>

<script>
import transport from 'vue-definition-utils/src/utils/transport'
import * as api from '../utils/definitionApi'
import language from '../language'

export default {
  name: 'definition-conditional',
  props: [
    'definition',
    'object',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'definitionContentId',
    'repeatableGroupCode',
    'showMultilanguage',
    'content',
    'parentObj',
    'parentDef',
    'reqObjForAdd',
    'definitionId',
    'modeView',
    'validateForm',
    'validateAddForm',
    'repeatableGroupId',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'callTask'
  ],
  data () {
    return {
      requestDefinition: null,
      requestObject: null,
      loading: false
    }
  },
  components: {
    DefinitionObj: () => import('./definitionObj.vue') // Webpack’s asynchronous import for recursivity components
  },
  methods: {
    getRequestObjectById (id) {
      // TODO OJO!!!!
      return transport.methods.getRequestObjectById(id, this.requestObject)
    },
    refreshDefinition (object) {
      if (this.requestObject) {
        var found = false
        for (var i = 0; i < this.requestObject.length && !found; i++) {
          if (this.requestObject[i].id === object.id) {
            this.requestObject[i] = transport.methods.modifyRequestObject(this.requestObject[i], object)
            found = true
            this.$emit('refreshDefinition', object)
          }
        }
      }
    },
    repeatableGroupModified (repeatableGroupObj) {
      this.$emit('repeatableGroupModified', repeatableGroupObj)
    },
    activateValidatingAddForm (id) {
      this.$emit('activateValidatingAddForm', id)
    },
    deactivateValidatingAddForm () {
      this.$emit('deactivateValidatingAddForm')
    },
    errorAddForm (formAddErrors) {
      this.$emit('errorAddForm', formAddErrors)
    },
    formAddSaved () {
      this.$emit('formAddSaved')
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    conditionalDefinitionChange () {
      if (this.requestDefinition) {
        var objects = []
        for (var i = 0; i < this.requestDefinition.length; i++) {
          var obj = this.getRequestObjectById(this.requestDefinition[i].id)
          if (obj) {
            objects.push(obj)
          }
        }
        this.$emit('conditionalDefinitionChange', this.definition.id, objects)
      } else {
        var object = this.object
        if (!object) {
          object = this.requestObject[0]
        }
        this.$emit('conditionalDefinitionChange', this.definition.id, [object])
      }
    },
    conditionalDefinitionChangeChild (conditionalFieldId, newReqObj) {
      this.$emit('conditionalDefinitionChange', conditionalFieldId, newReqObj)
    },
    setRequestDefinition () {
      var parentChoiceKeys = transport.methods.getChoiceKeys(this.parentObj)
      var definitionTask = this.getConditionalDefinitionTask()

      // conditional with definition task
      if (definitionTask) {
        if (parentChoiceKeys) {
          this.loading = true
          this.requestDefinition = null
          api.call({
            domainEndpoint: this.type.domainEndpoint,
            url: definitionTask.type.endpoint,
            token: null,
            version: null,
            method: 'POST',
            lang: this.getLang(),
            authorization: this.authorization,
            data: {
              id: this.definitionContentId,
              code: this.repeatableGroupCode,
              requestObject: [this.parentObj]
            }
          })
            .then(resp => {
              if (resp.requestResult) {
                this.requestDefinition = resp.requestDefinition

                if (resp.requestObject) {
                  this.requestObject = resp.requestObject
                } else {
                  var emptyRequestObject = transport.methods.getEmptyRequestObject(this.requestDefinition)
                  if (emptyRequestObject) {
                    this.requestObject = emptyRequestObject
                  }
                }

                if (this.requestObject) {
                  for (var i = 0; i < this.requestObject.length; i++) {
                    this.requestObject[i].conditionalFieldId = this.definition.id
                  }
                  this.$emit('refreshConditionalFieldId', this.requestObject)
                }

                this.conditionalDefinitionChange()
              } else {
                this.requestDefinition = null
              }
              this.loading = false
            })
            .catch(err => {
              console.error(err)
            })
        } else {
          this.requestDefinition = null
          this.requestObject = null
          this.conditionalDefinitionChange()
        }

      // conditional fields inside original definition
      } else {
        this.requestDefinition = null
        this.$nextTick(() => {
          var conditionalDefinition = transport.methods.getConditionalDefinition(parentChoiceKeys, this.parentObj.id, this.definition.children)
          var emptyRequestObject = null
          if (conditionalDefinition) {
            this.requestDefinition = [conditionalDefinition]

            var aux = null
            if (this.reqObjForAdd) {
              aux = transport.methods.getRequestObjectById(conditionalDefinition.id, [this.reqObjForAdd])
            } else {
              aux = transport.methods.getRequestObjectById(conditionalDefinition.id, this.content.requestObject)
            }

            if (aux) {
              this.requestObject = [aux]
            } else {
              emptyRequestObject = transport.methods.getEmptyRequestObject(this.requestDefinition)
              this.requestObject = emptyRequestObject
              this.requestObject[0].conditionalFieldId = this.definition.id
            }
          } else {
            if (this.requestDefinition) {
              emptyRequestObject = transport.methods.getEmptyRequestObject(this.requestDefinition)
            } else {
              emptyRequestObject = transport.methods.getEmptyRequestObject([this.definition])
            }

            if (emptyRequestObject) {
              this.requestObject = emptyRequestObject
              this.requestObject[0].conditionalFieldId = this.definition.id
            }
          }

          if (this.requestDefinition && this.requestDefinition[0] && this.requestDefinition[0].validation && !this.requestDefinition[0].validation.repeatable) {
            this.conditionalDefinitionChange()
          }
        })
      }
    },
    setRequestObject (newParentValue) {
      if (!newParentValue) {
        // if conditional inside repeatable
        if (this.reqObjForAdd) {
          this.requestObject = [this.reqObjForAdd]
        // if definition object is defined
        } else if (this.object) {
          this.requestObject = [this.object]
        // if request definition inside conditional is defined
        } else if (this.requestDefinition && this.requestDefinition.length === 1) {
          this.requestObject = [transport.methods.getRequestObjectById(this.requestDefinition[0].id, this.content.requestObject)]
        }
      } else {
        this.setRequestDefinition()
      }
    },
    refreshRepeatableGroupCode (code) {
      this.$emit('refreshRepeatableGroupCode', code)
    },
    getConditionalDefinitionTask () {
      var result = null
      if (this.parentDef.task) {
        for (var i = 0; i < this.parentDef.task.length && !result; i++) {
          if (this.parentDef.task[i].type.id === 'definition') {
            result = this.parentDef.task[i]
          }
        }
      }
      return result
    },
    getLang (key) {
      return language(this.language, key)
    },
    callSaveByFieldChange (alreadyValidated) {
      this.$emit('callSaveByFieldChange', alreadyValidated)
    }
  },
  beforeMount () {
    this.setRequestDefinition()
    this.setRequestObject(false)
  },
  watch: {
    parentObj: {
      handler: function (newVal) {
        this.setRequestObject(true)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .conditional {
    .conditional-loading {
      .vue-simple-spinner {
        margin-top: 42px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/conditional.vue